var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQuestionIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1473_4938)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7071 0.139996C12.2938 -0.141125 10.8289 0.00315663 9.49759 0.554595C8.1663 1.10603 7.02843 2.03986 6.22786 3.23799C5.4273 4.43612 5 5.84474 5 7.28572C5 7.7591 5.38376 8.14286 5.85714 8.14286C6.33053 8.14286 6.71429 7.7591 6.71429 7.28572C6.71429 6.18379 7.04104 5.10661 7.65324 4.1904C8.26544 3.27418 9.13558 2.56008 10.1536 2.13839C11.1717 1.7167 12.2919 1.60637 13.3726 1.82134C14.4534 2.03632 15.4461 2.56694 16.2253 3.34612C17.0045 4.1253 17.5351 5.11804 17.7501 6.19879C17.9651 7.27954 17.8547 8.39976 17.433 9.41781C17.3255 9.67741 16.9276 10.1878 16.3038 10.7636C15.7057 11.3158 15.0218 11.8165 14.4738 12.0905C13.2739 12.6905 12.3704 13.2281 11.89 14.2255C11.6579 14.7077 11.5495 15.2431 11.4932 15.84C11.4372 16.4338 11.4286 17.1463 11.4286 18C11.4286 18.4734 11.8123 18.8571 12.2857 18.8571C12.7591 18.8571 13.1429 18.4734 13.1429 18C13.1429 17.1394 13.1526 16.5034 13.1999 16.0009C13.247 15.5016 13.3269 15.1928 13.4345 14.9693C13.6338 14.5555 14.016 14.236 15.2405 13.6238C15.9782 13.2549 16.7943 12.644 17.4667 12.0232C18.1135 11.4261 18.7566 10.7022 19.0168 10.0738C19.5683 8.74255 19.7126 7.27764 19.4314 5.86435C19.1503 4.45106 18.4564 3.15287 17.4375 2.13394C16.4186 1.11501 15.1204 0.421117 13.7071 0.139996ZM12.2857 24C12.9958 24 13.5714 23.4244 13.5714 22.7143C13.5714 22.0042 12.9958 21.4286 12.2857 21.4286C11.5756 21.4286 11 22.0042 11 22.7143C11 23.4244 11.5756 24 12.2857 24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1473_4938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question_icon.362a081f.svg";
export { ForwardRef as ReactComponent };